export const PostData = 'PostData'
export const SetTitle = 'SetTitle'
export const SetOffice = 'SetOffice'
export const SetDepartment = 'SetDepartment'
export const SetFile = 'SetFile'
export const SetWorkFlow = 'SetWorkFlow'
export const GetRequest = 'GetRequest'
export const ClearRequest = 'ClearRequest'